import React, { useState } from "react";
import { useLocation, Link } from 'react-router-dom';
import { useAdminLogout } from "./useAdminLogout";
import { useAdminAuthContext } from "./useAdminAuthContext";

export const AdminSideMenu = () => {
  const { admin } = useAdminAuthContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { logout } = useAdminLogout();
  const location = useLocation(); // To track the current location

  // Function to add active class based on the current path
  const isActivePath = (path) => location.pathname === path ? 'bg-gray-800' : 'hover:bg-gray-700';

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleLogoutClick = () => {
    logout();
  }

  return (
    <>
      {/* Sidebar */}
      <div
        className={`bg-black text-white w-64 transition-transform transform ${
          isMenuOpen ? "translate-x-0" : "-translate-x-64"
        } md:translate-x-0 md:static fixed z-10 h-full max-h-screen overflow-y-auto`}
      >
        {/* Close Button for Mobile */}
        <button
          onClick={toggleMenu}
          className="absolute top-4 right-4 md:hidden text-white text-2xl"
        >
          ✕
        </button>

        {/* Sidebar Header */}
        <div className="p-4 text-lg font-bold bg-gray-900">
          <Link to="/administrator/dashboard">SpaClock Admin</Link>
        </div>

        {/* Menu List */}
        <ul className="space-y-3 mt-6">
          {/* Manage Admin Menu - Only visible if admin role is master */}

          <li>
              <Link
                to="/administrator/timereport/read"
                className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/timereport/read')} hover:bg-gray-700 transition duration-200`}
              >
                Readonly TR
              </Link>
          </li>
         
          <li>
              <Link
                to="/administrator/timereport/simple"
                className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/timereport/simple')} hover:bg-gray-700 transition duration-200`}
              >
                Timereport
              </Link>
          </li>

          <li>
              <Link
                to="/administrator/changerequest/manage"
                className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/changerequest/manage')} hover:bg-gray-700 transition duration-200`}
              >
                Changerequest
              </Link>
          </li>

          <li>
              <Link
                to="/administrator/employee/manage"
                className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/employee/manage')} hover:bg-gray-700 transition duration-200`}
              >
                Employees
              </Link>
          </li>

          <li>
              <Link
                to="/administrator/store/manage"
                className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/store/manage')} hover:bg-gray-700 transition duration-200`}
              >
                Stores
              </Link>
          </li>
         
          {admin.role === 'master' && (
            <li>
              <Link
                to="/administrator/admin/manage"
                className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/admin/manage')} hover:bg-gray-700 transition duration-200`}
              >
                Admins
              </Link>
            </li>

          )}

       
       

          <li>
              <Link
                to="/administrator/timereport/manage"
                className={`w-full text-left px-6 py-2 ${isActivePath('/administrator/timereport/manage')} hover:bg-gray-700 transition duration-200`}
              >
                Timereport - Detailed
              </Link>
          </li>

          {/* Logout Button */}
          <li>
            <button
              onClick={handleLogoutClick}
              className="w-full text-left px-6 py-2 hover:bg-gray-700 transition duration-200"
            >
              Logout
            </button>
          </li>
        </ul>
      </div>

      {/* Toggle Button for Mobile */}
      <button
        onClick={toggleMenu}
        className={`md:hidden fixed top-4 left-4 px-6 py-3 bg-black text-white rounded mb-4 z-20 ${
          isMenuOpen ? "hidden" : "block"
        }`}
      >
        Toggle Menu
      </button>
    </>
  );
};
